
import {Component, Prop, Vue} from 'vue-property-decorator';
import {Editor, EditorContent, EditorMenuBar} from 'tiptap';
import {
  Blockquote,
  Bold,
  BulletList,
  Code,
  CodeBlock,
  HardBreak,
  Heading,
  History,
  Italic,
  Link,
  ListItem,
  OrderedList,
  Strike,
  TodoItem,
  TodoList,
  Underline
} from "tiptap-extensions";
import {EDITOR_MENUBAR_BACKGROUND} from '@/configs/colors';
import RteBtn from '@/components/shared/RichTextEditor/rteBtn.vue';

@Component({
  components: {RteBtn, EditorMenuBar, EditorContent}
})
export default class RichTextEditor extends Vue {
  // Les props
  @Prop() private value!: string

  // Les propriétés
  private menubar_background = EDITOR_MENUBAR_BACKGROUND
  private editor: Editor | null = null

  // Les propriétés calculées
  // Les hooks
  public mounted() {
    // this.valueChange();
    this.editor = new Editor({
      content: this.value,
      onUpdate: ({getHTML}) => {
        this.$emit('input', getHTML())
      },
      extensions: [
        new Blockquote(),
        new CodeBlock(),
        new HardBreak(),
        new Heading({levels: [1, 2, 3]}),
        new BulletList(),
        new OrderedList(),
        new ListItem(),
        new TodoItem(),
        new TodoList(),
        new Bold(),
        new Code(),
        new Italic(),
        new Link(),
        new Strike(),
        new Underline(),
        new History()
      ]
    })
  }

  public beforeDestroy() {
    if (this.editor) {
      this.editor.destroy()
    }
  }

  // Les méthodes surveillées
  // Les méthodes
  // Les méthodes statiques
}
